<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-center column wrap>

      <v-flex x12>
        <v-layout align-center justify-center>
          <img src="https://scai.ingana.com.co/img/convenios/logo_20180413_093840.png" style="width: 120px">
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout align-center ajustify-center>
          <h1 class="pa-0">LICEO FESAN</h1>
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout align-center ajustify-center>
          <h3 class="pa-0">Proceso de Admisión</h3>
        </v-layout>
      </v-flex>

      <v-flex x12 sm8 md4 v-if="initForm">
        <v-card class="elevation-12 mt-5">
          <v-card-text>

            <v-layout align-center justify-center>
              <v-btn color="primary"
                     @click="initForm = false">Nueva Solicitud
              </v-btn>
              <v-btn color="primary"
                     :loading="loading"
                     :disabled="loading"
                     @click="modificarSolicitud('')">Modificar Solictud
              </v-btn>
            </v-layout>

            <v-form v-on:submit.prevent="modificarSolicitud('')" v-show="showRadicado">
              <v-text-field
                prepend-icon="library_books" name="radicado"
                label="Número Radicado" type="text"
                v-model="codigo"
              ></v-text-field>

              <v-layout align-center justify-center>
                <v-btn color="primary"
                       small @click="modificarSolicitud('')"
                       :loading="loading"
                       :disabled="loading">
                  <v-icon center dark>edit</v-icon>
                </v-btn>
                <v-btn color="success" small @click="imprimirSolicitud">
                  <v-icon center dark>local_printshop</v-icon>
                </v-btn>
              </v-layout>
            </v-form>
          </v-card-text>

        </v-card>
      </v-flex>

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :timeout="3000">
        {{ text_snack }}
      </v-snackbar>

      <v-flex xs12 v-if="!initForm" style="min-width: 100%">
        <v-stepper v-model="paso" alt-labels>
          <v-stepper-header>
            <v-stepper-step :complete="paso > 1" step="1">Datos Personales</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="paso > 2" step="2">Datos Familiares</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="paso > 3" step="3">Acudiente</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="paso > 4" step="4">Responsable Económico</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form>
                <v-container>
                  <v-layout row wrap>

                    <v-flex xs12 sm6 md2>
                      <v-autocomplete
                        v-model="form.acapersona_preinscripcion.tipoidentificacion_id"
                        :items="tipo_identificacion"
                        label="Tipo Identificación"
                        name="tipoidentificacion_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('tipoidentificacion_id')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.acapersona_preinscripcion.identificacion"
                        v-validate="'required'"
                        :error-messages="errors.collect('identificacion')"
                        name="identificacion" label="Identificación*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="form.acapersona_preinscripcion.nombres"
                        v-validate="'required'"
                        :error-messages="errors.collect('nombres')"
                        name="nombres" label="Nombres*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="form.acapersona_preinscripcion.apellidos"
                        v-validate="'required'"
                        :error-messages="errors.collect('apellidos')"
                        name="apellidos" label="Apellidos*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-menu
                        ref="menu1"
                        :close-on-content-click="false"
                        v-model="menu1"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="form.acapersona_preinscripcion.fecha_nacimiento"
                          label="Fecha Nacimiento*"
                          persistent-hint
                          readonly
                          type="text"
                          v-validate="'required'"
                          :error-messages="errors.collect('fecha_nacimieto')"
                          name="fecha_nacimiento"
                        ></v-text-field>
                        <v-date-picker ref="picker"
                                       :max="new Date().toISOString().substr(0, 10)"
                                       locale="es-Es" v-model="fecha_nac" no-title
                                       @input="menu1 = false"></v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-autocomplete
                        v-model="form.acapersona_preinscripcion.pais_id"
                        :items="paises"
                        label="Nacionalidad*"
                        name="pais_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('pais_id')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-autocomplete
                        v-model="departamento_id"
                        :items="departamentos"
                        label="Departamento*"
                        name="departamento_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('departamento_id')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-autocomplete
                        v-model="form.acapersona_preinscripcion.municipio_id"
                        :items="municipios"
                        label="Ciudad*"
                        name="municipio_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('municipio_id')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="form.acapersona_preinscripcion.direccion"
                        v-validate="'required'"
                        :error-messages="errors.collect('direccion')"
                        name="direccion" label="Direccion*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.acapersona_preinscripcion.celular"
                        v-validate="'required'"
                        :error-messages="errors.collect('celular')"
                        name="celular" label="Celular*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="form.semestre_id"
                        :items="cursos"
                        label="Curso al que ingresará*"
                        name="semestre_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('semestre_id')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-select
                        v-model="form.es_repitente"
                        :items="item_repitente"
                        label="¿Es Repitente?"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="form.colegio_ultimo_grado"
                        v-validate="'required'"
                        :error-messages="errors.collect('colegio_ultimo_grado')"
                        name="colegio_ultimo_grado" label="Colegio donde cursó el último grado*"
                        type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-select
                        v-model="form.anio_ultimo_grado"
                        :items="anios"
                        label="Año*"
                        v-validate="'required'"
                        :error-messages="errors.collect('anio')"
                        name="anio"
                      ></v-select>
                      <!--<v-text-field
                        v-model="form.anio_ultimo_grado"
                        name="anio_ultimo_grado" label="Año" type="text"></v-text-field>-->
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-form>

              <v-layout row wrap text-xs-center>
                <v-flex xs12 class="text-lg-right">
                  <v-btn
                    small
                    color="primary"
                    @click="validForm(2)"
                    :loading="loading"
                    :disabled="loading"
                  >
                    Siguiente
                  </v-btn>
                </v-flex>
              </v-layout>

            </v-stepper-content>

            <v-stepper-content step="2">
              <v-subheader>Información del padre</v-subheader>
              <v-form>
                <v-container>
                  <v-layout row wrap>

                    <v-flex xs12 sm6 md2>
                      <v-select
                        v-model="form.padre.actualmente_vive"
                        :items="item_actualmente_vive"
                        label="¿Actualmente Vive?"
                      ></v-select>
                    </v-flex>


                    <v-flex xs12 sm6 md2 v-if="form.padre.actualmente_vive < 2">
                      <v-autocomplete
                        v-model="form.padre.acapersona_preinscripcion.tipoidentificacion_id"
                        :items="tipo_identificacion"
                        label="Tipo Identificación"
                        name="tipoidentificacion_idPadre"
                        v-validate="'required'"
                        :error-messages="errors.collect('tipoidentificacion_idPadre')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.identificacion"
                        v-validate="'required'"
                        :error-messages="errors.collect('identificacionPadre')"
                        name="identificacionPadre" label="Identificación*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.nombres"
                        v-validate="'required'"
                        :error-messages="errors.collect('nombresPadre')"
                        name="nombresPadre" label="Nombres*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.apellidos"
                        v-validate="'required'"
                        :error-messages="errors.collect('apellidosPadre')"
                        name="apellidosPadre" label="Apellidos*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.direccion"
                        v-validate="'required'"
                        :error-messages="errors.collect('direccionPadre')"
                        name="direccionPadre" label="Direccion*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.celular"
                        v-validate="'required'"
                        :error-messages="errors.collect('celularPadre')"
                        name="celularPadre" label="Celular*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.ocupacion"
                        name="ocupacionPadre" label="Ocupación" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.padre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.padre.acapersona_preinscripcion.telefono_empresa"
                        name="telefonoEmpresaPadre" label="Teléfono empresa" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 md3 v-if="form.padre.actualmente_vive < 2 && !form.madre.acudiente">
                      <v-select
                        v-model="form.padre.acudiente"
                        :items="item_repitente"
                        label="¿Es Acudiente?"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm4 md3
                            v-if="form.padre.actualmente_vive < 2 &&
                              !form.madre.responsable_economico && !form.acudiente.responsable_economico">
                      <v-select
                        v-model="form.padre.responsable_economico"
                        :items="item_repitente"
                        label="¿Es responsable económico?"
                      ></v-select>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-form>

              <v-subheader>Información de la Madre</v-subheader>

              <v-form>
                <v-container>
                  <v-layout row wrap>

                    <v-flex xs12 sm6 md2>
                      <v-select
                        v-model="form.madre.actualmente_vive"
                        :items="item_actualmente_vive"
                        label="¿Actualmente Vive?"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.madre.actualmente_vive < 2">
                      <v-autocomplete
                        v-model="form.madre.acapersona_preinscripcion.tipoidentificacion_id"
                        :items="tipo_identificacion"
                        label="Tipo Identificación"
                        name="tipoidentificacion_idMadre"
                        v-validate="'required'"
                        :error-messages="errors.collect('tipoidentificacion_idMadre')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.identificacion"
                        v-validate="'required'"
                        :error-messages="errors.collect('identificacionMadre')"
                        name="identificacionMadre" label="Identificación*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.nombres"
                        v-validate="'required'"
                        :error-messages="errors.collect('nombresMadre')"
                        name="nombresMadre" label="Nombres*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.apellidos"
                        v-validate="'required'"
                        :error-messages="errors.collect('apellidosMadre')"
                        name="apellidosMadre" label="Apellidos*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.direccion"
                        v-validate="'required'"
                        :error-messages="errors.collect('direccionMadre')"
                        name="direccionMadre" label="Direccion*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.celular"
                        v-validate="'required'"
                        :error-messages="errors.collect('celularMadre')"
                        name="celularMadre" label="Celular*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.ocupacion"
                        name="ocupacionMadre" label="Ocupación" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="form.madre.actualmente_vive < 2">
                      <v-text-field
                        v-model="form.madre.acapersona_preinscripcion.telefono_empresa"
                        name="telefonoEmpresaMadre" label="Teléfono empresa" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 md3 v-if="form.madre.actualmente_vive < 2 && !form.padre.acudiente">
                      <v-select
                        v-model="form.madre.acudiente"
                        :items="item_repitente"
                        label="¿Es Acudiente?"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm4 md3
                            v-if="form.madre.actualmente_vive < 2 &&
                              !form.padre.responsable_economico && !form.acudiente.responsable_economico">
                      <v-select
                        v-model="form.madre.responsable_economico"
                        :items="item_repitente"
                        label="¿Es Responsable Económico?"
                      ></v-select>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-form>

              <v-layout row wrap text-xs-center>
                <v-flex xs12 class="text-lg-right">
                  <v-btn small flat @click="paso = 1">Atras</v-btn>
                  <v-btn
                    small
                    color="primary"
                    @click="validForm(3)"
                    :loading="loading"
                    :disabled="loading"
                  >
                    Siguiente
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="3">

              <v-form>
                <v-container>
                  <v-layout row wrap>

                    <v-flex xs12 sm6 md2>
                      <v-autocomplete
                        v-model="form.acudiente.acapersona_preinscripcion.tipoidentificacion_id"
                        :items="tipo_identificacion"
                        label="Tipo Identificación"
                        name="tipoidentificacion_idAcudiente"
                        v-validate="'required'"
                        :disabled="disabled_acudiente"
                        :error-messages="errors.collect('tipoidentificacion_idAcudiente')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.acudiente.acapersona_preinscripcion.identificacion"
                        v-validate="'required'"
                        :disabled="disabled_acudiente"
                        :error-messages="errors.collect('identificacionAcudiente')"
                        name="identificacionAcudiente" label="Identificación*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="form.acudiente.acapersona_preinscripcion.nombres"
                        v-validate="'required'"
                        :disabled="disabled_acudiente"
                        :error-messages="errors.collect('nombresAcudiente')"
                        name="nombresAcudiente" label="Nombres*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="form.acudiente.acapersona_preinscripcion.apellidos"
                        v-validate="'required'"
                        :disabled="disabled_acudiente"
                        :error-messages="errors.collect('apellidosAcudiente')"
                        name="apellidosAcudiente" label="Apellidos*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.acudiente.parentesco"
                        v-validate="'required'"
                        :disabled="disabled_acudiente"
                        :error-messages="errors.collect('parentesco')"
                        name="parentesco" label="Parentesco*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.acudiente.acapersona_preinscripcion.telefono"
                        name="telefonoAcudiente" label="Teléfono Fijo" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.acudiente.acapersona_preinscripcion.celular"
                        v-validate="'required'"
                        :disabled="disabled_acudiente"
                        :error-messages="errors.collect('celularAcudiente')"
                        name="celularAcudiente" label="Celular*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="form.acudiente.acapersona_preinscripcion.mail"
                        v-validate="{ is: conf_mailAcu, required: true, email: true}"
                        :error-messages="errors.collect('mailAcudiente')"
                        name="mailAcudiente" label="Correo Electrónico*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="conf_mailAcu"
                        v-validate="{ is: form.acudiente.acapersona_preinscripcion.mail, required: true, email: true}"
                        :error-messages="errors.collect('confMailAcudiente')"
                        name="confMailAcudiente" label="Confirmar Correo Electrónico*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                        v-model="form.este_colegio"
                        name="este_colegio"
                        v-validate="'required'"
                        rows="3"
                        :error-messages="errors.collect('este_colegio')"
                        label="¿Por qué desea estudiar en este Colegio?*"
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12 sm4 md3
                            v-if="!form.padre.responsable_economico && !form.madre.responsable_economico">
                      <v-select
                        v-model="form.acudiente.responsable_economico"
                        :items="item_repitente"
                        label="¿Es Responsable Económico?"
                      ></v-select>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-form>

              <v-flex xs12 class="text-lg-right">
                <v-btn small flat @click="paso = 2">Atras</v-btn>
                <v-btn
                  small
                  color="primary"
                  @click="validForm(4)"
                  :loading="loading"
                  :disabled="loading"
                >
                  Siguiente
                </v-btn>
              </v-flex>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-form>
                <v-container>
                  <v-layout row wrap>

                    <v-flex xs12 sm6 md2>
                      <v-autocomplete
                        v-model="form.responsable.acapersona_preinscripcion.tipoidentificacion_id"
                        :items="tipo_identificacion"
                        label="Tipo Identificación"
                        name="tipoidentificacion_idResponsable"
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('tipoidentificacion_idResponsable')"
                        persistent-hint
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.responsable.acapersona_preinscripcion.identificacion"
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('identificacionResponsable')"
                        name="identificacionResponsable" label="Identificación*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="form.responsable.acapersona_preinscripcion.nombres"
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('nombresResponsable')"
                        name="nombresResponsable" label="Nombres*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="form.responsable.acapersona_preinscripcion.apellidos"
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('apellidosResponsable')"
                        name="apellidosResponsable" label="Apellidos*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.responsable.parentesco"
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('parentescoResponsable')"
                        name="parentescoResponsable" label="Parentesco*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('direccionResponsable')"
                        v-model="form.responsable.acapersona_preinscripcion.direccion"
                        name="direccionResponsable" label="Dirección*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.responsable.acapersona_preinscripcion.telefono"
                        name="telefonoResponsable" label="Teléfono Fijo" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.responsable.acapersona_preinscripcion.celular"
                        v-validate="'required'"
                        :disabled="disabled_responsable"
                        :error-messages="errors.collect('celularResponsable')"
                        name="celularResponsable" label="Celular*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="form.responsable.acapersona_preinscripcion.mail"
                        v-validate="{ is: conf_mailResp, required: true, email: true}"
                        :error-messages="errors.collect('mailResponsable')"
                        name="mailResponsable" label="Correo Electrónico*" type="text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="conf_mailResp"
                        v-validate="{ is: form.responsable.acapersona_preinscripcion.mail, required: true, email: true}"
                        :error-messages="errors.collect('confMailResponsable')"
                        name="confMailResponsable" label="Confirmar Correo Electrónico*" type="text"></v-text-field>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-form>

              <v-flex xs12 class="text-lg-right">
                <v-btn small flat @click="paso = 3">Atras</v-btn>
                <v-btn
                  small
                  color="primary"
                  @click="validForm(5)"
                  :loading="loading"
                  :disabled="loading"
                >
                  Guardar
                </v-btn>
              </v-flex>


            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Api from '../service/api'
  import moment from 'moment'

  export default {
    name: "preinscripcion",
    data() {
      return {
        paso: 1,
        snackbar: false,
        color: 'success',
        text_snack: '',
        loading: false,
        initForm: true,
        showRadicado: false,
        item_repitente: [
          {
            value: 1,
            text: 'Si',
          },
          {
            value: 0,
            text: 'No',
          },
        ],
        item_actualmente_vive: [
          {
            value: 1,
            text: 'Si'
          },
          {
            value: 0,
            text: 'No'
          },
          {
            value: 2,
            text: 'N.A'
          }
        ],
        codigo: '',
        fecha_nac: '',
        menu1: false,
        conf_mailResp: '',
        conf_mailAcu: '',
        departamento_id: '',
        disabled_acudiente: false,
        anios: [],
        disabled_responsable: false,
        form: {
          es_repitente: 0,
          acapersona_preinscripcion: {
            pais_id: 82
          },
          padre: {
            actualmente_vive: 1,
            acudiente: 0,
            responsable_economico: 0,
            acapersona_preinscripcion: {}
          },
          madre: {
            actualmente_vive: 1,
            acudiente: 0,
            responsable_economico: 0,
            acapersona_preinscripcion: {}
          },
          acudiente: {
            responsable_economico: 0,
            acapersona_preinscripcion: {}
          },
          responsable: {
            acapersona_preinscripcion: {}
          }
        },
        validPasos: {
          1: ['tipoidentificacion_id', 'identificacion', 'nombres', 'apellidos', 'fecha_nacimiento', 'pais_id',
            'departamento_id', 'municipio_id', 'direccion', 'celular', 'semestre_id', 'colegio_ultimo_grado', 'anio'],
          2: ['tipoidentificacion_idPadre', 'identificacionPadre', 'nombresPadre', 'apellidosPadre',
            'direccionPadre', 'celularPadre', 'actualmente_vivePadre',
            'tipoidentificacion_idMadre', 'identificacionMadre', 'nombresMadre', 'apellidosMadre',
            'direccionMadre', 'celularMadre', 'actualmente_viveMadre'],
          3: ['tipoidentificacion_idAcudiente', 'identificacionAcudiente', 'nombresAcudiente', 'apellidosAcudiente',
            'celularAcudiente', 'mailAcudiente', 'confMailAcudiente', 'este_colegio', 'parentesco'],
          4: ['tipoidentificacion_idResponsable', 'identificacionResponsable', 'nombresResponsable',
            'apellidosResponsable', 'celularResponsable', 'mailResponsable', 'confMailResponsable',
            'parentescoResponsable', 'direccionResponsable']
        },
        paises: [],
        tipo_identificacion: [],
        departamentos: [],
        municipios: [],
        cursos: [],
      }
    },
    async mounted() {
      var initAnio = moment().format('YYYY')
      for (var i = 0; i < 20; i++) {

        this.anios.push(initAnio)
        initAnio -= 1
      }

      await localStorage.setItem('key', this.$route.params.key)
      Api(`query{
        pais {
          value: id
          text: nombre
        }
        tipoidentificacion {
          value: id
          text: name
        }
        departamento{
          value: id
          text: nombre
        }
        municipio{
          value: id
          text: nombre
          departamento_id
        }
        acasemestre{
          value: id
          text: nombre
        }
      }`).then(res => {

        this.tipo_identificacion = res.tipoidentificacion
        this.paises = res.pais
        this.departamentos = res.departamento
        this.municipios = res.municipio
        this.cursos = res.acasemestre

        if(this.$route.params.id){

          this.codigo = this.$route.params.id
          this.modificarSolicitud(this.$route.params.id)
        }
      })


    },
    watch: {
      fecha_nac(val) {
        this.form.acapersona_preinscripcion.fecha_nacimiento = this.formatDate(this.fecha_nac)
      },
      menu1(val) {
        val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    },
    methods: {
      imprimirSolicitud() {
        this.loading = true

        this.getDatosPreInscripcion().then(res => {
          this.loading = false
          if (!res) {
            this.snackbar = true
            this.color = 'error'
            this.text_snack = 'No se ha encontrado información'

            return false
          }

          this.$router.push({
            name: 'Impresiones',
            params: {
              codigo: this.codigo,
              datos: res
            }
          })
        })


      },
      getDatosPreInscripcion() {
        return Api(`{
  acapre_inscripcion(codigo: "${this.codigo}") {
    id
    codigo
    formatodocumento_id
    semestre_id
    es_repitente
    colegio_ultimo_grado
    anio_ultimo_grado
    este_colegio
    prepersona_id
    acapersona_preinscripcion{
      id
      tipoidentificacion_id
      identificacion
      nombre1
      nombre2
      apellido1
      apellido2
      nombres
      apellidos
      fecha_nacimiento
      pais_id
      municipio_id
      direccion
      celular
    }
    madre {
      id
      prepersona_id
      preacudiente_id
      parentesco
      responsable_economico
      acudiente
      actualmente_vive
      acapersona_preinscripcion {
        id
        tipoidentificacion_id
        identificacion
        nombre1
        nombre2
        apellido1
        apellido2
        nombres
        apellidos
        telefono
        celular
        mail
        direccion
        ocupacion
        telefono_empresa
      }
    }
    padre{
      id
      prepersona_id
      preacudiente_id
      parentesco
      responsable_economico
      acudiente
      actualmente_vive
      acapersona_preinscripcion {
        id
        tipoidentificacion_id
        identificacion
        nombre1
        nombre2
        apellido1
        apellido2
        nombres
        apellidos
        telefono
        celular
        mail
        direccion
        ocupacion
        telefono_empresa
      }
    }

    acudiente {
      id
      prepersona_id
      preacudiente_id
      parentesco
      responsable_economico
      acudiente
      acapersona_preinscripcion {
        id
        tipoidentificacion_id
        identificacion
        nombre1
        nombre2
        apellido1
        apellido2
        nombres
        apellidos
        telefono
        celular
        mail
        ocupacion
        telefono_empresa
      }
    }

    responsable {
      id
      prepersona_id
      preacudiente_id
      parentesco
      responsable_economico
      acudiente
      acapersona_preinscripcion {
        id
        tipoidentificacion_id
        identificacion
        nombre1
        nombre2
        apellido1
        apellido2
        nombres
        apellidos
        telefono
        celular
        mail
        ocupacion
        telefono_empresa
      }
    }
  }
}
`).then(res => {
          return res.acapre_inscripcion
        })
      },
      modificarSolicitud(id = '') {
        this.loading = true
        console.log(id)
        if (!this.showRadicado && id == '') {
          this.showRadicado = true
          this.loading = false
        } else {
          this.getDatosPreInscripcion().then(res => {
            this.loading = false
            if (!res) {
              this.snackbar = true
              this.color = 'error'
              this.text_snack = 'No se ha encontrado información'
              return false
            }

            this.form = res
            //this.departamento_id = res.acapre_inscripcion.

            if (!this.form.madre) {
              this.form.madre = {
                actualmente_vive: 2,
                acapersona_preinscripcion: {
                  tipoidentificacion_id: null,
                  nombres: '',
                  apellidos: '',
                  direccion: '',
                  celular: '',
                  telefono_empresa: '',
                  ocupacion: '',
                },
              }
            }

            if (!this.form.padre) {
              this.form.padre = {
                actualmente_vive: 2,
                acapersona_preinscripcion: {
                  tipoidentificacion_id: null,
                  nombres: '',
                  apellidos: '',
                  direccion: '',
                  celular: '',
                  telefono_empresa: '',
                  ocupacion: '',
                },
              }
            }

            this.municipios.forEach(val => {

              if (this.form.acapersona_preinscripcion.municipio_id == val.value)
                this.departamento_id = val.departamento_id
            })

            this.initForm = false
          })
        }
      },
      validForm(paso) {
        var valid = true

        this.validPasos[paso - 1].forEach(val => {
          this.$validator.validate(val).then(res => {
            if (valid && !res) {
              valid = false
            }
          })

        })

        setTimeout(() => {
          if (valid && paso < 5) {
            this.paso = paso
            this.loading = false
            if (paso == 3) {
              this.disabled_acudiente = true
              if (this.form.padre.acudiente) {
                var datosAcudiente = this.form.padre

                this.form.acudiente = {
                  id: datosAcudiente.id,
                  acapersona_preinscripcion: {
                    tipoidentificacion_id: datosAcudiente.acapersona_preinscripcion.tipoidentificacion_id,
                    identificacion: datosAcudiente.acapersona_preinscripcion.identificacion,
                    nombres: datosAcudiente.acapersona_preinscripcion.nombres,
                    apellidos: datosAcudiente.acapersona_preinscripcion.apellidos,
                    telefono: datosAcudiente.acapersona_preinscripcion.telefono,
                    celular: datosAcudiente.acapersona_preinscripcion.celular,
                    mail: datosAcudiente.acapersona_preinscripcion.mail
                  },
                  parentesco: 'Padre',
                }
              } else if (this.form.madre.acudiente) {
                var datosAcudiente = this.form.madre
                this.form.acudiente = {
                  id: datosAcudiente.id,
                  acapersona_preinscripcion: {
                    tipoidentificacion_id: datosAcudiente.acapersona_preinscripcion.tipoidentificacion_id,
                    identificacion: datosAcudiente.acapersona_preinscripcion.identificacion,
                    nombres: datosAcudiente.acapersona_preinscripcion.nombres,
                    apellidos: datosAcudiente.acapersona_preinscripcion.apellidos,
                    telefono: datosAcudiente.acapersona_preinscripcion.telefono,
                    celular: datosAcudiente.acapersona_preinscripcion.celular,
                    mail: datosAcudiente.acapersona_preinscripcion.mail
                  },
                  parentesco: 'Madre',
                }
              } else {
                this.disabled_acudiente = false
              }

            } else if (paso == 4) {
              this.disabled_responsable = true
              if (this.form.padre.responsable_economico) {
                var datosResponsable = this.form.padre

                this.form.responsable = {
                  id: datosResponsable.id,
                  acapersona_preinscripcion: {
                    tipoidentificacion_id: datosResponsable.acapersona_preinscripcion.tipoidentificacion_id,
                    identificacion: datosResponsable.acapersona_preinscripcion.identificacion,
                    nombres: datosResponsable.acapersona_preinscripcion.nombres,
                    apellidos: datosResponsable.acapersona_preinscripcion.apellidos,
                    telefono: datosResponsable.acapersona_preinscripcion.telefono,
                    celular: datosResponsable.acapersona_preinscripcion.celular,
                    mail: datosResponsable.acapersona_preinscripcion.mail,
                    direccion: datosResponsable.acapersona_preinscripcion.direccion,
                  },
                  parentesco: 'Padre',
                }
              } else if (this.form.madre.responsable_economico) {
                var datosResponsable = this.form.madre
                this.form.responsable = {
                  id: datosResponsable.id,
                  acapersona_preinscripcion: {
                    tipoidentificacion_id: datosResponsable.acapersona_preinscripcion.tipoidentificacion_id,
                    identificacion: datosResponsable.acapersona_preinscripcion.identificacion,
                    nombres: datosResponsable.acapersona_preinscripcion.nombres,
                    apellidos: datosResponsable.acapersona_preinscripcion.apellidos,
                    telefono: datosResponsable.acapersona_preinscripcion.telefono,
                    celular: datosResponsable.acapersona_preinscripcion.celular,
                    mail: datosResponsable.acapersona_preinscripcion.mail,
                    direccion: datosResponsable.acapersona_preinscripcion.direccion,
                  },
                  parentesco: 'Madre',
                }
              } else if (this.form.acudiente.responsable_economico) {
                var datosResponsable = this.form.acudiente
                this.form.responsable = {
                  id: datosResponsable.id,
                  acapersona_preinscripcion: {
                    tipoidentificacion_id: datosResponsable.acapersona_preinscripcion.tipoidentificacion_id,
                    identificacion: datosResponsable.acapersona_preinscripcion.identificacion,
                    nombres: datosResponsable.acapersona_preinscripcion.nombres,
                    apellidos: datosResponsable.acapersona_preinscripcion.apellidos,
                    telefono: datosResponsable.acapersona_preinscripcion.telefono,
                    celular: datosResponsable.acapersona_preinscripcion.celular,
                    mail: datosResponsable.acapersona_preinscripcion.mail,
                    direccion: datosResponsable.acapersona_preinscripcion.direccion,
                  },
                  parentesco: datosResponsable.parentesco,
                }
              } else {
                this.disabled_responsable = false
              }

            }
          } else if (valid) {
            this.loading = true
            Api(`mutation($datos: acapre_inscripcionInput){
              acapre_inscripcion(datos: $datos) {
                id
                msg
                ok
                codigo
              }
            }`, {
              datos: this.form
            }).then(res => {
              if (!res.acapre_inscripcion) {
                this.snackbar = true
                this.text_snack = 'Ha ocurrido un error al almacenar la información'
                this.loading = fals
                return false
              }

              this.color = 'error'
              if (res.acapre_inscripcion.ok) {
                this.color = 'success'
                this.snackbar = true
                this.text_snack = res.acapre_inscripcion.msg
                this.loading = false
                this.$router.push({
                  name: 'Impresiones',
                  params: {
                    codigo: res.acapre_inscripcion.codigo
                  }
                })
              }


            })
          } else {
            this.loading = false
          }

        }, 500)

      },
      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    }
  }
</script>

<style scoped>
  .customRadio {
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/preinscripcion.vue